import { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Page,
  List,
  Spacer,
  Loader,
  Spinner,
} from '@oliasoft-open-source/react-ui-library';
import { getCustomers } from 'client/store/entities/customer/customer';
import { generatePath, navigateToPath } from 'client/store/navigation/navigation';
import translations from 'client/internationalization/translation-map.json';
import { Link } from 'react-router-dom';
import { getCustomerState } from 'client/store/entities/customer/selectors';
import { RootState } from 'client/store/configureStore';
import { routes } from '../routes/routes';
import { TopBar } from '../top-bar/top-bar';

const companiesListStyle = { width: '400px', margin: '0 auto' };

const CompaniesContainer = ({ getCustomers, companiesList, isLoading }: PropsFromRedux) => {
  const { t } = useTranslation();
  useEffect(() => {
    getCustomers();
  }, []);

  return (
    <>
      <TopBar />
      <Page left={0}>
        {isLoading && (
          <Loader theme="light" cover>
            <Spinner dark />
          </Loader>
        )}
        <div style={companiesListStyle}>
          <span>
            {t(translations.pleaseSelectWhichOrganizationYouRepresent)}
          </span>
          <Spacer />
          <List
            list={companiesList}
            bordered
            noHeader
            testId="organization-list"
          />
        </div>
      </Page>
    </>

  );
};

const mapStateToProps = (state: RootState) => {
  const { customers, isLoading } = getCustomerState(state);
  const companiesList = {
    items: customers?.map(({ companyId, customerLabel }) => {
      const url = generatePath(routes.explore.pattern.path, {
        companyId,
      });
      return ({
        id: companyId,
        name: customerLabel,
        component: Link,
        url,
        onClick: () => navigateToPath(url),
      });
    }) || [],
  };

  return { companiesList, isLoading };
};

const mapDispatchToProps = { getCustomers };

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export const Companies = connector(CompaniesContainer);